import { ajax } from '@js/modules/ajax.js';

document.addEventListener('DOMContentLoaded', function() {
    const dateFilter = document.getElementById('dateFilter');
    const datePicker = document.getElementById('datePicker');

    if (!datePicker) return;

    const filterToggle = document.getElementById('filterToggle');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');

    if (filterToggle.checked && !datePicker.value) {
        const today = new Date().toISOString().split('T')[0];
        datePicker.value = today;
    }

    let previousDate = datePicker.value;

    updateDateControlsState(filterToggle.checked);

    filterToggle.addEventListener('change', handleFilterToggle);
    prevBtn.addEventListener('click', () => changeDate(-1));
    nextBtn.addEventListener('click', () => changeDate(1));

    datePicker.addEventListener('change', function() {
        if (datePicker.value && datePicker.value !== previousDate) {
            updateURLWithParams({
                date: datePicker.value
            });
            previousDate = datePicker.value;
        }
    });

    datePicker.addEventListener('blur', function() {
        if (datePicker.value && datePicker.value !== previousDate) {
            updateURLWithParams({
                date: datePicker.value
            });
            previousDate = datePicker.value;
        }
    });

    function handleFilterToggle(event) {
        const isFilterEnabled = event.target.checked;

        updateDateControlsState(isFilterEnabled);

        if (isFilterEnabled) {
            if (!datePicker.value) {
                const today = new Date().toISOString().split('T')[0];
                datePicker.value = today;
            }

            updateURLWithParams({
                filter: true,
                date: datePicker.value
            });
        } else {
            updateURLWithParams({
                filter: false,
                date: null
            });
        }
    }

    function changeDate(delta) {
        const currentDate = new Date(datePicker.value);
        currentDate.setDate(currentDate.getDate() + delta);

        const newDate = currentDate.toISOString().split('T')[0];
        datePicker.value = newDate;
        previousDate = newDate;

        updateURLWithParams({
            date: newDate
        });
    }

    function updateURLWithParams(params) {
        const actsList = document.getElementById('actsList')
        const url = new URL(window.location.href);
        url.searchParams.set('status', 'Новый запланированный');

        if (params.filter !== undefined) {
            url.searchParams.set('filter', params.filter.toString());
        }

        if (params.date !== undefined) {
            if (params.date) {
                url.searchParams.set('date', params.date);
            } else {
                url.searchParams.delete('date');
            }
        }

        // window.location.href = url.toString();
        history.pushState({}, '', url.toString());

        ajax(url, {
            expectHtml: true
        })
        .then(html => {
            actsList.innerHTML = html
        })
        .catch(err => console.error('Ошибка загрузки списка актов', err));
    }

    function updateDateControlsState(isEnabled) {
        datePicker.disabled = !isEnabled;
        prevBtn.disabled = !isEnabled;
        nextBtn.disabled = !isEnabled;
        dateFilter.style.opacity = isEnabled ? '1' : '0.5';
    }
});
